import { CssBaseline, StyledEngineProvider, ThemeOptions } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactNode } from 'react';

import Palette from './config/palette';
import Typography from './config/typography';
import componentsOverride from './overrides';

export default function ArmhrTheme({ children }: { children: ReactNode }) {
  const basePalette = Palette();
  const typography = Typography();

  const themeOptions: ThemeOptions = {
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024,
        lg: 1266,
        xl: 1440,
      },
    },
    mixins: {
      toolbar: {
        minHeight: 60,
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
    palette: basePalette,
    typography,
    sidebar: {
      width: 265,
      closedWidth: 60,
      background: {
        default: '#fff',
        dark: '#1e1e1e',
      },
      text: {
        primary: '#262626',
        secondary: 'rgba(38, 38, 38, 0.6)',
      },
      appearance: 'light',
      navItem: {
        selected: {
          text: '#1789FC',
          background: '#E6F2FF',
          borderRight: '3px solid #1789FC',
          hover: {
            text: '#1789FC',
            background: '#E6F2FF',
          },
        },
        default: {
          text: '#262626',
          hover: {
            text: '#1789FC',
            background: '#F5F5F5',
          },
        },
      },
      group: {
        label: 'rgba(38, 38, 38, 0.6)',
      },
    },
  };

  const newTheme = createTheme(themeOptions);
  newTheme.components = componentsOverride(newTheme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={newTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
